import './SimpleLoader.scss';

import React, {ReactNode, useEffect, useMemo, useState} from 'react';

type LoadingProps = {
    delay?: number;
    runFor?: number;
    loaded: boolean;
    lazy?: boolean;

    children?: ReactNode;
    className?: string;
};

type LoadingState = 'OFF' | 'RUNNING' | 'DONE';

const SimpleLoader = ({
    loaded,
    lazy = true,
    delay = 300,
    runFor = 500,
    children,
    className,
}: LoadingProps) => {
    const [loading, setLoading] = useState<LoadingState>('OFF');

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (!loaded) {
                setLoading('RUNNING');
            }
        }, delay);

        if (loaded && loading === 'OFF') {
            clearTimeout(timeoutId);
            setLoading('DONE');
        }

        return () => clearTimeout(timeoutId);
    }, [loaded, delay, loading]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (loading === 'RUNNING') {
                setLoading('DONE');
            }
        }, runFor);

        return () => clearTimeout(timeoutId);
    }, [loading, runFor]);

    const loaderClass = useMemo(() => {
        switch (loading) {
            case 'RUNNING':
                return 'loading-active';
            case 'DONE':
                if (loaded) {
                    return 'loading-done';
                } else {
                    return 'loading-active';
                }
            case 'OFF':
                return 'loading-off';
        }
    }, [loading, loaded]);

    return (
        <React.Fragment>
            <div className={`loading-component ${loaderClass} ${className || ''}`}></div>
            <div hidden={lazy && !loaded} className={`loaded-component ${loaderClass}`}>
                {children}
            </div>
        </React.Fragment>
    );
};

export default SimpleLoader;
